namespace $.$$ {

	export type $shm_projects_goal_thinking_entry = {
		id: string
		title: string
		text: string
		time: number
		finished: boolean
	}

	export class $shm_projects_goal_thinking extends $.$shm_projects_goal_thinking {

		part_rows() {
			return ( this.entries() as $shm_projects_goal_thinking_entry[] ).map( entry => this.Part( entry.id ) )
		}

		entry( id: string ) {
			return ( this.entries() as $shm_projects_goal_thinking_entry[] ).find( entry => entry.id === id )
		}

		status() {
			const time = ( this.entries() as $shm_projects_goal_thinking_entry[] ).at( -1 )?.time
			return time ? `Ответ агента · ${ new Date( time ).toLocaleString() }` : 'Выбери ответ агента в процессе'
		}

		part_title( id: string ) {
			const entry = this.entry( id )
			if( !entry ) return ''
			return `${ entry.title } · ${ entry.finished ? 'завершён' : 'идёт' }`
		}

		part_text( id: string ) {
			return this.entry( id )?.text ?? ''
		}

	}

}
